<div [ngClass]="typologyColor" class="typology-container">
  <mat-chip-listbox [disabled]="disabled">
    @for (affectation of affectationMap[typologyColor]; track affectation) {
    <mat-chip-option
      (click)="affectationClick(affectation)"
      [class.selected]="typology?.affectationKeys | includes : affectation.key"
      matTooltip="{{ affectation.description }}"
      #tooltip="matTooltip"
    >
      @if (typology?.affectationKeys | includes: affectation.key) {
      <mat-icon matChipAvatar>check </mat-icon>
      }
      {{ affectation.title }}
      @if (affectation.description) {
      <mat-icon (click)="tooltip.toggle()" matChipRemove>info </mat-icon>
      }
    </mat-chip-option>
    }
  </mat-chip-listbox>
  <ng-content></ng-content>
</div>
